import React, { Dispatch, SetStateAction } from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Currency } from '../../models/currency.model';
import { removeTooltip } from '../../tools/tooltip.tool';
import { legendInvalid, legendValid, legendValidInvalidRestart } from '../../tools/legend.data.entry.tool';
import { suffixLegend } from '../../scripts/name.legend.script';
import { expressions } from '../../libraries/regular.expressions.library';

import AppLegend from './Legend';

export interface AppInputRequirementRebateProps {
  content: {value: any, currency: Currency, index: number, sub_index: number},
  requirements: {list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]},
  setRequirements: Dispatch<SetStateAction<{list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]}>>
};

const AppInputRequirementRebate: React.FunctionComponent<AppInputRequirementRebateProps> = ({content, requirements, setRequirements}) => {
  const {lang} = StateLanguage()

  const handleChangeRebateTypeContentToRequirement = (item: string) => {
    let rebateType: string = (item === 'percentage') ? 'fixed' : (item === 'fixed') ? 'none' : (item === 'none') ? 'percentage' : 'none'

    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].rebate_type = rebateType
        temp_item.contents[content.sub_index].rebate_value = (rebateType === 'none') ? '' : temp_item.contents[content.sub_index].rebate_value
        temp_item.contents[content.sub_index].rebate_quantity = (rebateType === 'none') ? '' : temp_item.contents[content.sub_index].rebate_quantity
      }
      return temp_item
    })
    let tempRequirementsValid = requirements.valid.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].rebate_value = (rebateType === 'none' || ((rebateType === 'percentage' || rebateType === 'fixed') && tempRequirementsValue[content.index].contents[content.sub_index].rebate_value.length > 0))
        temp_item.contents[content.sub_index].rebate_quantity = (rebateType === 'none' || ((rebateType === 'percentage' || rebateType === 'fixed') && tempRequirementsValue[content.index].contents[content.sub_index].rebate_value.length > 0))
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue, valid: tempRequirementsValid})

    if ((rebateType === 'percentage' || rebateType === 'fixed') && tempRequirementsValue[content.index].contents[content.sub_index].rebate_value.length === 0 && tempRequirementsValue[content.index].contents[content.sub_index].rebate_quantity.length === 0) {
      legendInvalid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
    } else {
      switch (rebateType) {
        case 'percentage':
          if (expressions.percentage.test(tempRequirementsValue[content.index].contents[content.sub_index].rebate_value)) {
            legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          } else {
            legendInvalid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          }
          break;
        case 'fixed':
          if (expressions.currency.test(tempRequirementsValue[content.index].contents[content.sub_index].rebate_value)) {
            legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          } else {
            legendInvalid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          }
          break;
        case 'none':
          legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          legendValid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          break;
        default:
          legendValidInvalidRestart(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          legendValidInvalidRestart(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          break;
        }
    }

    removeTooltip()
  }

  const handleChangeRebateValueContentToRequirement = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].rebate_value = event.target.value
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue})
  }

  const handleChangeRebateQuantityContentToRequirement = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].rebate_quantity = event.target.value
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue})
  }

  const validateRebateContentToRequirement = () => {
    if ((requirements.value[content.index].contents[content.sub_index].rebate_type === 'percentage' || requirements.value[content.index].contents[content.sub_index].rebate_type === 'fixed') && requirements.value[content.index].contents[content.sub_index].rebate_value.length === 0 && requirements.value[content.index].contents[content.sub_index].rebate_quantity.length === 0) {
      let requerimentsValid = requirements.valid.map((temp_item, temp_index) => {
        if (content.index === temp_index) {
          temp_item.contents[content.sub_index].rebate_value = false
          temp_item.contents[content.sub_index].rebate_quantity = false
        }
        return temp_item
      })
      setRequirements({...requirements, valid: requerimentsValid})
      legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
      legendInvalid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
    } else {
      switch (requirements.value[content.index].contents[content.sub_index].rebate_type) {
        case 'percentage':
          if (expressions.percentage.test(requirements.value[content.index].contents[content.sub_index].rebate_value) && expressions.percentage.test(requirements.value[content.index].contents[content.sub_index].rebate_quantity)) {
            let requerimentsValid = requirements.valid.map((temp_item, temp_index) => {
              if (content.index === temp_index) {
                temp_item.contents[content.sub_index].rebate_value = true
                temp_item.contents[content.sub_index].rebate_quantity = true
              }
              return temp_item
            })
            setRequirements({...requirements, valid: requerimentsValid})
            legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
            legendValid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          } else {
            let requerimentsValid = requirements.valid.map((temp_item, temp_index) => {
              if (content.index === temp_index) {
                temp_item.contents[content.sub_index].rebate_value = expressions.percentage.test(requirements.value[content.index].contents[content.sub_index].rebate_value)
                temp_item.contents[content.sub_index].rebate_quantity = expressions.percentage.test(requirements.value[content.index].contents[content.sub_index].rebate_quantity)
              }
              return temp_item
            })
            setRequirements({...requirements, valid: requerimentsValid})
            legendInvalid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
            legendValid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          }
          break;
        case 'fixed':
          if (expressions.currency.test(requirements.value[content.index].contents[content.sub_index].rebate_value) && expressions.currency.test(requirements.value[content.index].contents[content.sub_index].rebate_quantity)) {
            let requerimentsValid = requirements.valid.map((temp_item, temp_index) => {
              if (content.index === temp_index) {
                temp_item.contents[content.sub_index].rebate_value = true
                temp_item.contents[content.sub_index].rebate_quantity = true
              }
              return temp_item
            })
            setRequirements({...requirements, valid: requerimentsValid})
            legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
            legendValid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          } else {
            let requerimentsValid = requirements.valid.map((temp_item, temp_index) => {
              if (content.index === temp_index) {
                temp_item.contents[content.sub_index].rebate_value = expressions.currency.test(requirements.value[content.index].contents[content.sub_index].rebate_value)
                temp_item.contents[content.sub_index].rebate_quantity = expressions.currency.test(requirements.value[content.index].contents[content.sub_index].rebate_quantity)
              }
              return temp_item
            })
            setRequirements({...requirements, valid: requerimentsValid})
            legendInvalid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
            legendValid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          }
          break;
        case 'none':
          legendValid(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          legendValid(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          break;
        default:
          legendValidInvalidRestart(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
          legendValidInvalidRestart(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
          break;
        }
    }
  }

  function isDisabledButton() {
    return requirements.valid[content.index].contents[content.sub_index].price_unit && Number(requirements.value[content.index].contents[content.sub_index].price_unit) < 0
  }

  function isDisabledInput() {
    if (requirements.valid[content.index].contents[content.sub_index].price_unit) {
      return (Number(requirements.value[content.index].contents[content.sub_index].price_unit) < 0)
    } else {
      return !(content.value.rebate_type === 'percentage' || content.value.rebate_type === 'fixed')
    }
  }

  return (
    <>
      <div className="position-relative">
        <input className="form-control form-control-solid fs-8 h-20px ps-2 pe-15" type="text" autoComplete="off" name="rebate-value" disabled={isDisabledInput()} value={content.value.rebate_value} onChange={handleChangeRebateValueContentToRequirement} onKeyUp={validateRebateContentToRequirement} onBlur={validateRebateContentToRequirement} />
        <button className="btn btn-bg-secondary btn-flex flex-center position-absolute translate-middle-y top-50 end-0 h-100 w-35px" type="button" disabled={isDisabledButton()} data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" data-bs-original-title={content.value.rebate_type === "percentage" ? lang.labels.thisOptionRebateIsPercentage : content.value.rebate_type === "fixed" ? lang.labels.thisOptionRebateIsFixedAmount : lang.labels.thisOptionRebateIsNone} onClick={() => handleChangeRebateTypeContentToRequirement(content.value.rebate_type)}>
          <span className="btn-label text-primary fw-bolder fs-7">
            {content.value.rebate_type === "percentage" ? '%' : content.value.rebate_type === "fixed" ? content.currency.symbol : "-0-"}
          </span>
        </button>
      </div>
      <div className="position-relative mt-1">
        <input className="form-control form-control-solid fs-8 h-20px ps-2 pe-10" type="text" autoComplete="off" name="rebate-quantity" disabled={isDisabledInput()} value={content.value.rebate_quantity} onChange={handleChangeRebateQuantityContentToRequirement} onKeyUp={validateRebateContentToRequirement} onBlur={validateRebateContentToRequirement} />
        <div className="position-absolute translate-middle-y top-50 end-0 me-2">
          <i className="d-flex align-items-start" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={!isDisabledButton() ? lang.labels.quantityMinimumForRebate : lang.labels.nonExistentRebateNegativePrice}><FaExclamationCircle /></i>
        </div>  
      </div>
      <AppLegend attribute={{check: requirements.valid[content.index].contents[content.sub_index].rebate_value, name: "requirement-content-rebate", index: content.index, sub_index: content.sub_index}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
    </>
  )
}

export default AppInputRequirementRebate;
